import classnames from 'classnames'
import { useTranslate } from 'react-polyglot'

import UpsalesSlider from '~/components/Cart/UpsalesSlider'
import { ProductHeaderSubtitle } from '~/components/UI/ProductHeader/HeaderSubtitle'

import { useProductHeaderProvider } from '~/providers/ProductPageProvider'

import { useGetProductsUpsales } from '~/hooks/useGetProductsUpsales'

import { CUSTOMIZER } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductUpsales {
  className?: string
}
export function ProductUpsales({ className }: ProductUpsales) {
  const t = useTranslate()
  const { shopifyId } = useProductHeaderProvider()
  const { data: items, isLoading } = useGetProductsUpsales([shopifyId])

  return (
    <div className={cx(css.ProductUpsales, className)}>
      <ProductHeaderSubtitle
        className={css.subtitle}
        text={t(CUSTOMIZER.COMPLETE_WITH)}
        withOptional
      />
      <UpsalesSlider
        className={cx(css.upsales)}
        items={items}
        loading={isLoading}
        layout="product-page"
      />
    </div>
  )
}
